import React from 'react';

import { format } from 'date-fns';
import cn from 'classnames';

import { Avatar } from 'components/Avatar/Avatar.component';
import { RoomAttributes } from 'lib/models/candidate-messages';
import { parseResponse } from 'lib/utils/parser';

import { OpportunityResponse } from 'lib/models/opportunity';
import { TouchpointType } from 'lib/models/touchpoint';
import styles from './MessageAvatar.module.scss';

interface MessageAvatarProps {
  room: RoomAttributes;
  size?: 'xlarge' | 'large' | 'small';
}

export const MessageAvatar = React.memo((props: MessageAvatarProps) => {
  const { room, size = 'large' } = props;
  const { receiver_name, created_for_type, receiver_icon_url, receiver } = room;

  const renderCalenderIcon = (start_date: string) => {
    const startDate = new Date(start_date);
    const month = format(startDate, 'LLL');
    const date = format(startDate, 'dd');

    return (
      <div
        className={cn(styles.MessageAvatarCalenderIcon, {
          [styles.smallCalendarIcon]: size === 'small',
          [styles.xlargeCalendarIcon]: size === 'xlarge',
        })}
      >
        <p className={styles.month}>{month.toUpperCase()}</p>
        <p className={styles.date}>{date}</p>
      </div>
    );
  };

  const renderAvatar = () => (
    <Avatar
      name={receiver_name}
      size={size}
      icon={receiver_icon_url}
      className={cn(styles.avatar, { [styles.large]: size === 'xlarge' })}
    />
  );

  const renderIcon = () => {
    if (created_for_type === null) {
      return renderAvatar();
    } else {
      const { start_date, touchpointable_type } = parseResponse(
        receiver as OpportunityResponse
      );
      if (start_date && touchpointable_type === TouchpointType.Event)
        return renderCalenderIcon(start_date);
      else return renderAvatar();
    }
  };

  return <>{renderIcon()}</>;
});

MessageAvatar.displayName = 'MessageAvatar';
